import { render, staticRenderFns } from "./KPIProgress.vue?vue&type=template&id=254fa795&scoped=true"
import script from "./KPIProgress.vue?vue&type=script&lang=js"
export * from "./KPIProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254fa795",
  null
  
)

export default component.exports